// desktop.guard.ts
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { Breakpoints } from '@angular/cdk/layout';
import { GlobalStore } from './store/global-store';
import { CanActivate, Router } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable({
    providedIn: 'root',
})
export class AdminGuard implements CanActivate {

    isAdmin$ = toSignal(inject(GlobalStore).isRoleAdmin$);
    constructor(
        private globalStore: GlobalStore, // Inject GlobalStore
        private router: Router
    ) { }

    canActivate(): Observable<boolean> {
        // Use map to transform the value emitted by the observable
        return this.globalStore.isRoleAdmin$.pipe(
            filter(x=>x!=undefined),
            map(isRoleAdmin => {
            if (isRoleAdmin) {
                return true; // Activate the route if isRoleAdmin is true
            } else {
                this.router.navigate(['/unauthorized']); // Redirect to unauthorized page if not admin
                return false;
            }
        }));
    }
}
@Injectable({
    providedIn: 'root',
})
export class ApproverAdminGuard implements CanActivate {

    // isAdmin$ = toSignal(inject(GlobalStore).isDisplayApprovals$);
    constructor(
        private globalStore: GlobalStore, // Inject GlobalStore
        private router: Router
    ) { }

    canActivate(): Observable<boolean> {
        // Use map to transform the value emitted by the observable
        return this.globalStore.isDisplayApprovals$.pipe(
            filter(x=>x!=undefined),
            map(isRoleAdmin => {
            if (isRoleAdmin) {
                return true; // Activate the route if isRoleAdmin is true
            } else {
                this.router.navigate(['/unauthorized']); // Redirect to unauthorized page if not admin
                return false;
            }
        }));
    }
}

